import * as thunkActions from './thunks';

const actions = {
  ...thunkActions,
};

export { actions };
